import React, { FC } from 'react';
import i18next from 'i18next';
import img from 'assets/errors/adblocker.svg';
import css from './styles.module.scss';

const AdBlocker: FC = () => (
  <div className={css.blocker}>
    <div className={css.blocker__img}>
      <img src={img} alt="Ошибка блокировщика рекламы" />
    </div>
    <h1 className={css.blocker__title}>
      {i18next.t('error_page.errAB.title')}
    </h1>
    <p className={css.blocker__text}>{i18next.t('error_page.errAB.text')}</p>
  </div>
);

export default AdBlocker;
